import { useEffect, useRef } from 'react';
import { TabContainer } from '../../../common/MUI';
import Events from '../../../../utilities/EventEmitter';
import drawConstant from '../../Settings/common/DrawTools/DrawConstant';
import { LOCATION_TAB } from './constants';
import useDowLocationData from './DOWMapping/useDowLocationData';
import { createLocationMappingProps, createDowMappingProps, createTabs } from './tabConfig';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import WithDrawer from '../../Dispatch/Common/Drawer/WithDrawer';
import { withFeatureFlags } from '../../../../userProfile/featureFlagsContext';
import appConstants from '../../../../appConstants';

const MarkLocation = ({
  mapId,
  glEventHub,
  terminalId,
  geoDataList,
  onTabChange,
  featureFlags,
  isDataLoaded,
  dowGeoDataList,
  enqueueSnackbar,
  onDeleteLocation,
  activeLocationTab,
  equipmentSizeList,
  updateDowGeoDataList,
  getLocationMappingData,
  isLocationDeleteInProgress,
  customerLocationMappingData
}) => {
  const isDeliveryLocationMappingEnabledRef = useRef(false);
  useEffect(() => {
    isDeliveryLocationMappingEnabledRef.current = featureFlags.isFeatureEnabled(
      appConstants.features.EnableDeliveryLocationMapping
    );
  }, [featureFlags]);

  const {
    getDowLocationMappingData,
    ...dowMappingHookProps
  } = useDowLocationData({ terminalId, enqueueSnackbar, updateDowGeoDataList });

  useEffect(() => {
    if (activeLocationTab === LOCATION_TAB.DOW_DELIVERY) {
      getDowLocationMappingData();
    }
  }, [activeLocationTab, getDowLocationMappingData]);

  const locationMappingProps = createLocationMappingProps({
    mapId,
    terminalId,
    glEventHub,
    geoDataList,
    isDataLoaded,
    onDeleteLocation,
    equipmentSizeList,
    getLocationMappingData,
    isLocationDeleteInProgress,
    customerLocationMappingData
  });

  const dowMappingProps = createDowMappingProps({
    mapId,
    terminalId,
    glEventHub,
    dowGeoDataList,
    getDowLocationMappingData,
    ...dowMappingHookProps
  });

  const tabs = createTabs({
    locationMappingProps,
    dowMappingProps,
    isDeliveryLocationMappingEnabled: isDeliveryLocationMappingEnabledRef.current
  });

  const handleTabChange = (newTabIndex) => {
    Events.emit(
      `${mapId}_${drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_CREATED_ON_MAP}`,
      'cancel',
      true
    );
    onTabChange(newTabIndex);
  };

  return <TabContainer tabs={tabs} onChange={handleTabChange} />;
};

export default compose(withSnackbar, WithDrawer, withFeatureFlags)(MarkLocation);
